import React, { Component } from 'react';
import {
  MovieContainer,
  MonitorContainer,
  KnowContainer,
  ConquerContainer,
  BreatheContainer,
  LineUpRev2Container,
  LineUpGlowContainer,
  LineUpMintContainer,
  LineUpElementContainer,
} from '../intro/containers';
import IntroContents from '../../assets/contents/intro';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import IntroHelmet from '../intro/components/IntroHelmet';

class IntroPage extends Component {
  state = { selected: null, direction: null };
  _swipe = {};
  minDistance = 50;
  timeoutId = null;

  componentDidMount() {
    this.setState({ selected: 'movie' });
    document.body.style.overflowY = 'hidden';
  }

  componentDidUpdate() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
    }
  }

  onTouchStart = (event) => {
    const touch = event.touches[0];
    this._swipe = { x: touch.clientX };
  };

  onTouchMove = (event) => {
    const { selected, direction } = this.state;

    if (
      !!selected &&
      !direction &&
      event.changedTouches &&
      event.changedTouches.length
    ) {
      this._swipe.swiping = true;
    }
  };

  onTouchEnd = (event) => {
    const { selected } = this.state;
    const { match } = this.props;
    const lang = match.params.lang;
    const touch = event.changedTouches[0];
    const calcX = touch.clientX - this._swipe.x;
    const absX = Math.abs(calcX);
    if (this._swipe.swiping && absX > this.minDistance) {
      if (calcX > 0) {
        selected !== 'movie' && this.onPrev();
      } else {
        lang === 'ko'
          ? selected !== 'lineUpMint' && this.onNext()
          : selected !== 'lineUpGlow' && this.onNext();
      }
    }
    this._swipe = {};
  };
  onPrev = () => {
    this.setState({ selected: null, direction: 'prev' });
  };
  onNext = () => {
    this.setState({ selected: null, direction: 'next' });
  };
  onSelect = (section) => {
    this.setState({ selected: section }, this.clearDirection);
  };
  clearDirection = () => {
    this.timeoutId = window.setTimeout(
      () => this.setState({ direction: null }),
      1000
    );
  };
  onClose = ({ isFinish = false }) => {
    const { selected } = this.state;

    ReactGA.event({
      category: 'Mobile Intro',
      action: isFinish ? 'Close' : 'Dismiss',
      label: selected,
    });

    this.dismiss();
  };
  onSignUp = () => {
    const { selected } = this.state;

    ReactGA.event({
      category: 'Mobile Intro',
      action: 'Sign up',
      label: selected,
    });

    this.dismiss();
  };
  dismiss = () => {
    if (window.android && window.android.dismissIntro) {
      window.android.dismissIntro();
    } else {
      window.location.replace('awair://dismiss');
    }
  };
  onShopNow = (product) => {
    const { match } = this.props;
    const lang = match.params.lang;
    let url;

    ReactGA.event({
      category: 'Mobile Intro',
      action: 'Shop Now',
      label: product,
    });

    switch (product) {
      case 'rev2':
        url =
          lang === 'ko'
            ? 'https://kr.getawair.com/#/?utm_source=intro&utm_medium=inapp&utm_campaign=rev2&utm_term=rev2'
            : 'https://getawair.com/?utm_source=intro&utm_medium=inapp&utm_campaign=rev2&utm_term=rev2';
        break;

      case 'element':
        url =
          lang === 'ko'
            ? 'https://kr.getawair.com/#/?utm_source=intro&utm_medium=inapp&utm_campaign=element&utm_term=element'
            : 'https://getawair.com/?utm_source=intro&utm_medium=inapp&utm_campaign=element&utm_term=element';
        break;

      case 'glow':
        url =
          'https://getawair.com/pages/awair-glow?utm_source=intro&utm_medium=inapp&utm_campaign=glow&utm_term=glow';
        break;

      case 'mint':
        url =
          'https://kr.getawair.com/#/mint?utm_source=intro&utm_medium=inapp&utm_campaign=mint&utm_term=mint';
        break;

      default:
        url =
          'https://getawair.com/?utm_source=intro&utm_medium=inapp&utm_campaign=rev2&utm_term=rev2';
    }

    if (window.android && window.android.presentBrowser) {
      window.android.presentBrowser(url);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.presentBrowser &&
      window.webkit.messageHandlers.presentBrowser.postMessage
    ) {
      window.webkit.messageHandlers.presentBrowser.postMessage(url);
    } else {
      window.location.href = url;
    }
  };

  render() {
    const {
      onSelect,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      onClose,
      onSignUp,
      onShopNow,
    } = this;
    const { selected, direction } = this.state;
    const { match, OS } = this.props;
    const lang = match.params.lang;

    const list =
      lang === 'ko'
        ? [
            { key: 'movie', Component: MovieContainer },
            { key: 'monitor', Component: MonitorContainer },
            { key: 'know', Component: KnowContainer },
            { key: 'conquer', Component: ConquerContainer },
            { key: 'breathe', Component: BreatheContainer },
            { key: 'lineUpRev2', Component: LineUpRev2Container },
            { key: 'lineUpMint', Component: LineUpMintContainer },
          ]
        : [
            { key: 'movie', Component: MovieContainer },
            { key: 'monitor', Component: MonitorContainer },
            { key: 'know', Component: KnowContainer },
            { key: 'conquer', Component: ConquerContainer },
            { key: 'breathe', Component: BreatheContainer },
            { key: 'lineUpElement', Component: LineUpElementContainer },
            { key: 'lineUpGlow', Component: LineUpGlowContainer },
          ];

    return (
      <main
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={{
          position: 'relative',
          overflow: 'hidden',
          height: '100vh',
          background: '#000000',
          fontFamily: `'sf-pro-display', 'Noto Sans KR', Arial, sans-serif`,
        }}
      >
        <IntroHelmet url={match.url} selected={selected} />

        {list.map(({ key, Component }) => {
          const isSelected = key === selected;

          return (
            <Component
              key={key}
              isSelected={isSelected}
              contents={
                IntroContents[lang]
                  ? IntroContents[lang][key]
                  : IntroContents['en'][key]
              }
              commonContents={IntroContents['common'][key]}
              direction={direction}
              OS={OS}
              lang={lang}
              onSelect={onSelect}
              onSignUp={onSignUp}
              onClose={onClose}
              onShopNow={onShopNow}
            />
          );
        })}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  OS: state.core.OS,
});

export default connect(mapStateToProps, null)(IntroPage);



// WEBPACK FOOTER //
// ./src/app/pages/IntroPage.js